import { default as React } from 'react'
import { BoxProps, default as MuiBox } from '@mui/material/Box'

export type { BoxProps }

const Box = <D extends React.ElementType, P = Record<string, never>>(props: BoxProps<D, P>) => {
  return <MuiBox {...props} />
}

export default Box
